// import { Grid } from '@intech/web-ui';
import React from 'react';
import { PrestacaoEntidade } from '../../../../../entidades';
import { ModalItem } from './ModalItem';
import { SmallButton, WrapRow, BloatDiv, Title } from './styles';

interface ItemProps {
  prestacao: PrestacaoEntidade;
  // onClose: () => void;
}

export const PrestacaoModalConteudo: React.FC<ItemProps> = ({
  prestacao,
  // onClose
}) => {

  function ToMoney(Valor: number | undefined) {
    if (Valor == undefined) {
      return 0;
    }
    return (
      "R$ " + Valor.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  return (
    <div>
      <Title>Valor da Prestação: {ToMoney(prestacao.VL_PRESTACAO!)}</Title>
      <WrapRow>
        <ModalItem
          leftText={"Principal"}
          rightText={prestacao.VL_PRINCIPAL!}
          money
        />
      </WrapRow>
      <WrapRow>
        <ModalItem
          leftText={"Juros"}
          rightText={prestacao.VL_JUROS!}
          money
        />
      </WrapRow>
      <WrapRow>
        <ModalItem
          leftText={"Seguro"}
          rightText={prestacao.VL_TX_SEGURO!}
          money
        />
      </WrapRow>
      <WrapRow>
        <ModalItem
          leftText={"Taxa Administração"}
          rightText={prestacao.VL_TX_ADM!}
          money
        />
      </WrapRow>
      <WrapRow>
        <ModalItem
          leftText={"Multa"}
          rightText={prestacao.VL_MULTA!}
          money
        />
      </WrapRow>
      <WrapRow>
        <ModalItem
          leftText={"Mora"}
          rightText={prestacao.VL_MORA!}
          money
        />
      </WrapRow>
      <WrapRow>
        <ModalItem
          leftText={"Desconto"}
          rightText={prestacao.VL_DESCONTO!}
          money
        />
      </WrapRow>
      {/* <WrapRow>
        <BloatDiv></BloatDiv>
        <BloatDiv>
          <SmallButton onClick={onClose}>
            {"OK, Entendi!"}
          </SmallButton>
        </BloatDiv>
      </WrapRow> */}
    </div>
  );
}